import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Redirect,
  Route,
} from "react-router-dom";
import { useDispatch } from "react-redux";
import NotFound from "./pages/NotFound";
import GlobalLoading from "./components/GlobalLoading";
import { login } from "./redux/actions/userActionCreators";
import CustomRoute from "./routes/CustomRoute";
import PrivateRoute from "./routes/PrivateRoute";
import AuthRoute from "./routes/AuthRoute";
import { Suspense, useEffect, useState } from "react";
import i18n from "./i18n";
import LocaleContext from "./LocaleContext";
import Surveys from "./pages/Surveys/index";
import ProfileOrganization from "./pages/profileOrganization/ProfileOrganization";
import ProfileDetails from "./pages/profileOrganization/Profile";
import Login from "./pages/login";
import Reports from "./pages/reports";
import ConsultReport from "./pages/reports/ConsultReport";
import Register from "./pages/register";
import ForgotPassword from "./pages/forgotPassword";
import ConfirmAccount from "./pages/register/ConfirmAccount";
import ResetPassword from "./pages/forgotPassword/ResetPassword";
// import Weaknesses from "./pages/weaknesses";
// import Home from "./pages/Home";
import RoleManagement from "./pages/roleManagement";
import { ConfirmProvider } from "material-ui-confirm";
import OrgaController from "./components/OrgaController";
import PublicRoute from "./routes/PublicRoute";
import EditOrganizationProfile from "./pages/profileOrganization/editOrganizationProfile";
import MakeUseCase from "./pages/useCase/MakeUseCase";
// import Assets from "./pages/asset";
// import UseCases from "./pages/useCase";
// import Risks from "./pages/risks";
import RiskDetails from "./pages/risks/RiskDetails";
import OrganizationList from "./pages/enterprise";
import IncompletedQuiz from "./pages/quiz/IncompletedQuiz";
import CompletedQuiz from "./pages/quiz/CompletedQuiz";
import ForwardedQuiz from "./pages/quiz/ForwardedQuiz";
import BaseQuiz from "./pages/quiz/BaseQuiz";
import MakeQuizz from "./pages/Surveys/MakeQuizz";
import ConfirmUser from "./pages/roleManagement/ConfirmUser";
import ForwardedAlreadyAnswered from "./pages/quiz/ForwardedAlreadyAnswered";
import OrganizationAssets from "./pages/organizationAssets";
import ConfirmInvitationModal from "./components/ConfirmInvitationModal";
import AutomaticLogOutControl from "./components/AutomaticLogOutControl";
import TabManagement from "./pages/tabManagement";
import axios from "axios";
import PowerBi from "./pages/powerBi";
// import TefDetails from "./pages/powerBi/dashboards/info/tefDetails";
import EditOrganizationHandler from "./components/Profile/EditOrganizationHandler";
import ExportHandler from "./pages/powerBi/dashboards/exportHandler";
import Workstation from "./pages/workstation";
import Evaluation from "./pages/evaluation";
import ThreatLandscape from "./pages/threatLandscape";
import StaticPage from "./pages/static-page";
import DiscoveredAssets from "./pages/organizationAssets/Discovered_Assets";
import RiskScenarios from "./pages/riskScenarios";
import RiskAssessment from "./pages/riskAssessment";
import { clearRiskAssessmentStorage } from "./utils/storageCleanup";

function App() {
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");
  const refreshToken = localStorage.getItem("refreshToken");
  const storedUser = localStorage.getItem("user");

  const revokeGoogleToken = async (googleRefreshToken) => {
    try {
      const response = await axios.post(
        "https://accounts.google.com/o/oauth2/revoke",
        new URLSearchParams({
          token: googleRefreshToken,
        }),
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );

      if (response.status !== 200) {
        console.error("Failed to revoke Google token:", response.data);
        return {
          error: "Failed to revoke Google token",
          details: response.data,
        };
      }

      return { success: "Token revoked successfully" };
    } catch (error) {
      console.error("An error occurred:", error);
      return { error: "An error occurred", details: error.message };
    }
  };

  let parsedStoredUser = null;
  if (storedUser) {
    try {
      parsedStoredUser = JSON.parse(storedUser);
    } catch (e) {
      parsedStoredUser = null;
    }
  }
  const enterpriseDefaultPath =
    parsedStoredUser?.account_type === "enterprise"
      ? parsedStoredUser?.role === "cytailor_admin"
        ? "/super_admin_management"
        : "/enterprise"
      : "/quizzes";

  useEffect(() => {
    clearRiskAssessmentStorage();
  }, []);

  if (token && storedUser) {
    dispatch(login(token));
  } else if (refreshToken) {
    const googleRefreshToken = refreshToken;
    revokeGoogleToken(googleRefreshToken).then((response) => {
      if (response.error) {
        console.error(response.error, response.details);
      } else {
        console.log(response.success);
      }
    });
    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
  }

  // useEffect(()=>{
  //   dispatch(login(token))
  // },[dispatch,token])

  const [locale, setLocale] = useState(
    i18n?.language?.indexOf("fr") !== -1 ? "fr" : "en"
  );
  i18n.on("languageChanged", (lng) =>
    setLocale(i18n?.language?.indexOf("fr") !== -1 ? "fr" : "en")
  );

  return (
    <>
      <ConfirmProvider>
        <GlobalLoading locale={locale} />

        <LocaleContext.Provider value={{ locale, setLocale }}>
          <Suspense fallback={<GlobalLoading locale={locale} />}>
            <Router>
              <ConfirmInvitationModal />
              <OrgaController />
              <AutomaticLogOutControl />
              <Switch>
                <Route exact path="/" component={StaticPage} />
                <Route
                  exact
                  path="/login/fr"
                  render={() => {
                    i18n.changeLanguage("fr");
                    return (
                      <Redirect
                        to={{
                          pathname: "/login",
                        }}
                      />
                    );
                  }}
                />
                <Route
                  exact
                  path="/login/en"
                  render={() => {
                    i18n.changeLanguage("en");
                    return (
                      <Redirect
                        to={{
                          pathname: "/login",
                        }}
                      />
                    );
                  }}
                />

                {/*chat bot code*/}

                {/*<Route*/}
                {/*    path="/chat"*/}
                {/*    render={() => {*/}
                {/*        const token = localStorage.getItem("token");*/}
                {/*        const userRole = JSON.parse(localStorage.getItem("user"))?.role;*/}

                {/*        // Check if the user is authenticated*/}
                {/*        if (!token) {*/}
                {/*            return (*/}
                {/*                <Redirect*/}
                {/*                    to={{*/}
                {/*                        pathname: "/login",*/}
                {/*                    }}*/}
                {/*                />*/}
                {/*            );*/}
                {/*        }*/}

                {/*        // Check if the user has the "enterprise_user" role*/}
                {/*        if (userRole !== "enterprise_user") {*/}
                {/*            return (*/}
                {/*                <Redirect*/}
                {/*                    to={{*/}
                {/*                        pathname: "/enterprise",*/}
                {/*                    }}*/}
                {/*                />*/}
                {/*            );*/}
                {/*        }*/}

                {/*        // If authenticated and role is correct, render the ChatBot component*/}
                {/*        return <PrivateRoute path="/chat" component={ChatBot} />*/}
                {/*    }}*/}
                {/*/>*/}

	                <Route
	                  path="/profile-organization/fr"
	                  render={() => {
	                    i18n.changeLanguage("fr");
	                    if (token) {
	                      if (parsedStoredUser?.account_type === "enterprise") {
	                        return (
	                          <Redirect
	                            to={{
	                              pathname: enterpriseDefaultPath,
	                            }}
	                          />
	                        );
	                      } else {
                        return (
                          <Redirect
                            to={{
                              pathname: "/quizzes",
                            }}
                          />
                        );
                      }
                    } else {
                      return (
                        <Redirect
                          to={{
                            pathname: "/profile-organization",
                          }}
                        />
                      );
                    }
                  }}
                />
	                <Route
	                  path="/profile-organization/en"
	                  render={() => {
	                    i18n.changeLanguage("en");
	                    if (token) {
	                      if (parsedStoredUser?.account_type === "enterprise") {
	                        return (
	                          <Redirect
	                            to={{
	                              pathname: enterpriseDefaultPath,
	                            }}
	                          />
	                        );
	                      } else {
                        return (
                          <Redirect
                            to={{
                              pathname: "/quizzes",
                            }}
                          />
                        );
                      }
                    } else {
                      return (
                        <Redirect
                          to={{
                            pathname: "/profile-organization",
                          }}
                        />
                      );
                    }
                  }}
                />

                <CustomRoute
                  exact
                  path="/profile-organization"
                  component={ProfileOrganization}
                />

                {/*<CustomRoute*/}
                {/*  exact*/}
                {/*  path="/quizzes"*/}
                {/*  component={Surveys}*/}
                {/*/>*/}

                {/* <CustomRoute
                  exact
                  path="/quizzes/:category?"
                  component={Surveys}
                /> */}
                <CustomRoute
                  path="/base_quizzes/:quizId"
                  component={BaseQuiz}
                />

                <PrivateRoute
                  path="/asset_inventory"
                  component={DiscoveredAssets}
                />
                {/* <PrivateRoute
                  path="/asset_inventory"
                  component={ThreatLandscape}
                /> */}
                <PrivateRoute path="/evaluation" component={Evaluation} />
                {/* <PrivateRoute path="/workstation" component={Workstation} /> */}
                <PrivateRoute path="/profile" component={ProfileDetails} />
                <PrivateRoute
                  path="/risk-scenarios"
                  component={RiskScenarios}
                />
                <PrivateRoute
                  path="/risk-assessment/:orgaId?"
                  component={RiskAssessment}
                />
                <PrivateRoute exact path="/reports" component={Reports} />
                <PrivateRoute
                  path="/make-usecase/:caseId"
                  component={MakeUseCase}
                />
                <PrivateRoute
                  path="/orga_assets"
                  component={OrganizationAssets}
                />
                {/* <PrivateRoute path="/assets" component={Assets} /> */}
                <PrivateRoute path="/enterprise" component={OrganizationList} />
                <PrivateRoute
                  path="/super_admin_management"
                  allowedRoles={["cytailor_admin"]}
                  component={TabManagement}
                />
                <PrivateRoute
                  exact
                  path="/risk_profile/:page?"
                  component={PowerBi}
                />
                <PrivateRoute
                  exact
                  path="/export/risk_profile"
                  component={ExportHandler}
                />
                {/* <PrivateRoute path="/risk_profile/tef" component={TefDetails} /> */}

                {/* <PrivateRoute exact path="/weakness" component={Weaknesses} /> */}
                {/* <PrivateRoute exact path="/risk" component={Risks} /> */}
                <PrivateRoute path="/risk/:riskId" component={RiskDetails} />
                <PrivateRoute exact path="/users" component={RoleManagement} />
                <AuthRoute path="/login" component={Login} />
                <AuthRoute path="/register" component={Register} />
                <AuthRoute
                  path="/confirm-email/:idAccount"
                  component={ConfirmAccount}
                />
                <AuthRoute path="/forgot-password" component={ForgotPassword} />
                {/* <PrivateRoute exact path="/usecases" component={UseCases} /> */}
                <PrivateRoute
                  exact
                  path="/Already-Answered"
                  component={ForwardedAlreadyAnswered}
                />
                <PrivateRoute
                  exact
                  path="/incompleted_quizzes/:quizId"
                  component={IncompletedQuiz}
                />
                <PrivateRoute
                  exact
                  path="/completed_quizzes/:quizId"
                  component={CompletedQuiz}
                />
                <PrivateRoute
                  path="/make-quizz/:quizzId"
                  component={MakeQuizz}
                />
                <PrivateRoute
                  path="/edit-profile-organization"
                  component={EditOrganizationHandler}
                />
                <PrivateRoute
                  exact
                  path="/forwarded_usecase/:forwardId"
                  component={ForwardedQuiz}
                />

                <AuthRoute
                  path="/reset-password/:token"
                  component={ResetPassword}
                />

                <AuthRoute
                  path="/confirm-user/:token"
                  component={ConfirmUser}
                />

                <CustomRoute
                  exact
                  path="/consult-report/:reportId"
                  component={ConsultReport}
                />

                {/* <PrivateRoute
                  exact
                  path="/reports/:reportId"
                  component={Reports}
                /> */}

                <PublicRoute
                  exact
                  path="/reports/non_authenticated_user/:reportId"
                  component={Reports}
                />
                <CustomRoute component={NotFound} />
              </Switch>
            </Router>
          </Suspense>
        </LocaleContext.Provider>
      </ConfirmProvider>
    </>
  );
}

export default App;
